/* eslint-disable max-len */
import React, { useState } from 'react';
import lodash from "lodash";
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import HelpMessage from 'components/util/helpers/HelpMessage';
import { Field } from "formik";


const HelpComponent = ({ helpMessage, icon = "far fa-question-circle" }) =>
    <HelpMessage delay={0} message={helpMessage} style={{ backgroundColor: '#e8ecf0' }} forceShow={true}>
        <i class={icon} style={{ color: "#c0c5d0", cursor: "pointer", marginLeft: "0.5rem" }}></i>
    </HelpMessage>

const CommentComponent = ({ name, setFieldValue, values }) => {

    // For multiple fields
    const regIdx = /\[[0-9]+\]$/g
    const commentName = name.replace(new RegExp(regIdx), "") + "_comment"
    const value = lodash.get(values, commentName)

    const [comment, setComment] = useState(value)
    const [overlayShow, setOverlayShow] = useState(false)

    const onSave = () => {
        setFieldValue(commentName, comment);
        setOverlayShow(false)
    }
    const onRemove = () => {
        setFieldValue(commentName, "")
        setOverlayShow(false)
    }

    return <OverlayTrigger key="bottom" placement="bottom" trigger="click"
        show={overlayShow}
        onToggle={(show) => setOverlayShow(show)}
        overlay={
            <Popover id="popover-positioned-right">
                <Popover.Body className="p-2"
                    style={{ backgroundColor: "#eaecf0", border: "1px solid #e0e5ea", color: "black", borderRadius: "10px" }}>
                    <div>
                        <Field as="textarea" value={comment} rows={4}
                            style={{ minWidth: "15rem" }}
                            onChange={e => setComment(e.target.value)}
                            class={"form-control"} />
                        <div className="d-flex justify-content-end mt-2">
                            <div className="bg-white mr-1">
                                <a className="btn btn-sm btn-outline-primary py-1" onClick={onSave}>Guardar</a>
                            </div>
                            <div className="bg-white">
                                <a className="btn btn-sm btn-outline-secondary py-1" style={{ border: "1px solid #b0b0b0" }} onClick={onRemove}>Quitar</a>
                            </div>
                        </div>

                    </div>
                </Popover.Body>
            </Popover>
        }
    >
        {
            value == null || value == "" ?
                <a className={"btn btn-sm btn-outline-secondary " + (overlayShow ? "active" : "")}>
                    <i class="far fa-comments mr-2 ml-1" style={{ color: "#c5cad5", cursor: "pointer" }}></i> Agregar comentario
                </a> :
                <a className={"btn btn-sm btn-accent " + (overlayShow ? "active" : "")}>
                    <i class="far fa-comment mr-2 ml-1" style={{ cursor: "pointer" }}></i> Comentarios
                </a>
        }
    </OverlayTrigger >
}

export { HelpComponent, CommentComponent }